import { Button, HStack, Input } from "@chakra-ui/react";
import React, { useCallback, useState } from "react";
import { IFileInfo } from "../_types_";
import { uploadFile } from "../apis/file.api";

interface IProps {
  title?: string;
  onUploadSuccess?: (file: IFileInfo) => void;
}
export default function UploadFile({ title, onUploadSuccess }: IProps) {
  const [fileInfo, setFileInfo] = useState<IFileInfo>();

  const handleUploadFile = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      try {
        if (event.target.files) {
          const file = await uploadFile(event.target.files);
          setFileInfo(file);
          onUploadSuccess && onUploadSuccess(file);
        }
      } catch (er) {
        console.log(er);
      }
    },
    [onUploadSuccess]
  );

  return (
    <HStack position="relative" bg="white" w="full">
      <Input
        borderRadius="0px"
        placeholder={`Chọn file ${title}...`}
        value={fileInfo?.name || ""}
      />
      <Button
        position="absolute"
        right="0"
        borderRadius="0px"
        bg="blue.700"
        color="white"
      >
        File upload
      </Button>
      <Input
        type="file"
        height="100%"
        width="100%"
        position="absolute"
        top="0"
        left="0"
        opacity="0"
        aria-hidden="true"
        accept="image/*, .pdf, .shp,.shx, .dbf"
        onChange={handleUploadFile}
      />
    </HStack>
  );
}
